import ContentfulImage from '@Shared/components/contentful/ContentfulImage'
import ContentfulText from '@Shared/components/contentful/ContentfulText'
import newRelic from '@Shared/lib/new-relic'
import { find } from 'lodash'
import { sprintf } from 'sprintf-js'

export default {
  components: {
    ContentfulImage,
    ContentfulText
  },
  methods: {
    contentfulText (slug) {
      let contentfulObject = find(this.content.Text, {'Name': slug})

      if (contentfulObject === null || contentfulObject === undefined) {
        throw new Error(`Contentful text object with name ${slug} not found`)
      }

      return contentfulObject
    },
    contentfulImage (slug) {
      let contentfulObject = find(this.content.Images, {'Name': slug})

      if (contentfulObject === null || contentfulObject === undefined) {
        throw new Error(`Contentful image object with name ${slug} not found`)
      }

      return contentfulObject
    },
    contentfulTextFormatted (slug, data = null) {
      let contentfulObject = this.contentfulText(slug)

      let result

      try {
        result = sprintf(contentfulObject.Content, data)
      } catch (e) {
        newRelic.noticeError(e)
        result = contentfulObject.Content
      }

      return result
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/mixins/contentful.js